export const isError = (error: unknown): error is Error => {
  return error instanceof Error
}
export const getErrorName = (error: unknown) =>
  isError(error) ? error.name : typeof error === 'string' ? error : ''
